
import { createCtrl, createGridNode } from 'root/designer/utils/createClass';
import { calcColWidth } from 'root/designer/utils/utils.js';
import { message } from 'antd';
import { routerRedux } from 'dva/router';
import {
  queryIndustryApplicationLayout,
  updateIndustryApplicationLayout,
  addIndustryApplicationLayout,
  queryIndustryApplicationLayouts,
  getWidgetsByGroup
} from 'root/designer/services/api';
import { getInstanceById } from 'root/utils/supQuery/query.js';
import { getStoreConfig, setStoreConfig } from 'root/designer/routes/AppDesign/utils/store';
import { MYOWNLOCK, OTHERSLOCK } from 'root/designer/utils/constants';

import { fetchTemplates } from '../services/workflowApi';
import { lock } from '../services/pageManager';

const root = createCtrl({
  id: 'ctrl-root',
  parentId: 0,
  type: 'Page', // 特殊页面级type
  index: 0,
  config: {
    style: {
      height: '100%',
      margin: '0 auto'
    }
  },
  freshId: ''
});
root.children = ['ctrl-0'];

const colObj = createCtrl({
  id: 'ctrl-0',
  parentId: 'ctrl-root',
  type: 'Col',
  index: 0,
  config: {
    ratio: '1',
    style: {}
  }
});
colObj.config.style.height = '98%';
const defaultCtrls = {
  'ctrl-root': root,
  'ctrl-0': colObj
};

function* fetchLayout(id, call, put) {
  const res = yield call(queryIndustryApplicationLayout, id);
  if (!res) {
    message.error('数据请求失败');
    return false;
  }
  const parentRes = yield call(queryIndustryApplicationLayouts, res.parentId);
  if (!(parentRes && parentRes.layout)) {
    message.error('数据请求失败');
    return false;
  }
  if (res.context !== '{}') {
    yield put({
      type: 'fetchPageInfo',
      pageStatus: MYOWNLOCK,
      payload: {
        context: res.context,
        // layout: JSON.parse(parentRes.layout)
        page: parentRes
      }
    });
  }
}

/**
 * 判断当前容器内和新拖入组件是否类型一致
 * @param {Array} childList 子组件列表
 * @param {String} id 当前元素id
 */
function isSameType(childList, id) {
  return ((childList.includes('ctrl') || childList.includes('grid')) && !id.includes('ctrl') && !id.includes('grid')) ||
  (childList && !childList.includes('ctrl') && !childList.includes('grid') && (id.includes('ctrl') || id.includes('grid')));
}

// 测试代码 发布后删除
// if (window.localStorage.ctrl) {
//   defaultCtrls = JSON.parse(window.localStorage.ctrl);
// }
// 测试代码 发布后删除
export default {
  namespace: 'canvas',
  state: {
    pageStatus: 0,
    instance: {},
    // 显示隐藏参数临时位置
    toggleConfig: {},
    propertiesConfigs: [],
    ctrls: null,
    gridInfo: {},
    proxy: {},
    ctrlIndex: 1,
    requestGroup: null,
    widgets: [],
    isVisible: false,
    selectedCtrlId: ''
    // 布局属性是否已经保存
    // layoutConfigSaveState: true
  },
  effects: {
    // 选中元素
    *getEditComp({ instance, componentType }, { put }) {
      try {
        // 获取控件属性配置项信息
        const result = yield import(`root/designer/components/WidgetStorage/Widgets/${componentType}/config.js`);
        window.selectedInstance = instance; // 用于键盘事件
        yield put({
          type: 'gotEditComp',
          instance,
          result: result.default
        });
      } catch (error) {
        console.log(error);
      }
    },
    *getWidgetsByGroup({ groupName, intl }, { call, put }) {
      let response = [];
      if (groupName.groupName === 'temp') {
        response = yield call(fetchTemplates);
        if (response && response.list) {
          response = response.list;
        }
      } else {
        response = yield call(getWidgetsByGroup, groupName, intl);
      }
      yield put({
        type: 'gotWidgetsByGroup',
        requestGroup: groupName,
        widgets: response || []
      });
    },
    *checkLockStatus({ pageId }, { call, put }) {
      const pageStatus = yield call(lock, pageId);

      if (pageStatus.locked === OTHERSLOCK) {
        yield put({
          type: 'displayDiaglog',
          pageStatus: pageStatus.locked,
          isVisible: true,
          lockStaffName: pageStatus.staffName,
          lastModifiedTime: pageStatus.lastModifiedTime
        });
      }
    },
    *fetchLayout({ id, appId, pageId }, { call, put }) {
      if (!appId && !pageId) {
        return yield fetchLayout(id, call, put);
      }

      const pageStatus = yield call(lock, pageId);

      let url = `/design/industry-application-mgr/application-editor/${appId}?appId=${appId}&pageId=${pageId}`;
      if (window.ISAPPCREATOR) {
        url = `/layout/industry-application-mgr/application-editor/${appId}?appId=${appId}&pageId=${pageId}`;
      }
      if (pageStatus && !pageStatus.locked) {
        const newStatus = yield call(lock, pageId, 'POST');
        if (newStatus && newStatus.locked === MYOWNLOCK) {
          yield fetchLayout(id, call, put);
        } else {
          // 不是自己上锁的状态需要跳转会页面列表页面
          // TODO 需要提示信息
          yield put(routerRedux.push(url));
        }
      } else {
        // TODO 需要提示信息
        yield put(routerRedux.push(url));
      }
    },
    *unlock({ pageId, isLeave }, { call }) {
      yield call(lock, pageId, 'DELETE', isLeave);
    },
    *updateLayout({ data, isPreview = false, url, id, isLocked, isAutoSave = false }, { call, put }) {
      if (isLocked === OTHERSLOCK) return;
      const response = yield call(updateIndustryApplicationLayout, data, id);
      if (isPreview) return;
      if (response.location) {
        if (!isAutoSave) message.success('保存成功');
        if (url) {
          yield call(lock, id, 'DELETE');
          yield put(routerRedux.push(url));
        }
        window.__LAYOUT_CONFIG_DATA_SAVE_STATE__ = true;
        // yield put({
        //   type: 'updateLayoutConfigSaveState',
        //   layoutConfigSaveState: true
        // });
      } else {
        if (parseInt(response.code, 10) === 202 && isAutoSave) {
          message.error('自动保存失败');
        }
        // message.error('数据请求失败');
        return false;
      }
    },
    *addLayout({ payload, gridInfo, insertIndex = null, callback }, { call, put }) {
      payload.context = JSON.stringify({ data: defaultCtrls });
      const response = yield call(addIndustryApplicationLayout, payload);
      if (!(response && response.location)) {
        return false;
      }
      gridInfo = JSON.parse(gridInfo);
      gridInfo.id = response.location;
      const params = {
        type: insertIndex === null ? 'newFirstLayout' : 'normalLayout',
        gridInfo
      };
      yield put({
        type: 'industryApplicationLayout/increaseLayout',
        gridInfo,
        insertIndex
      });
      if (callback) callback(params);
    },
    *deleteCtrl({ payload }, { put }) {
      try {
        const resultConfig = yield import('root/designer/components/WidgetStorage/Widgets/Page/config.js');
        yield put({
          type: 'deleteCtrlAction',
          payload: {
            ...payload,
            resultConfig
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  },
  reducers: {
    initCtrls(state) {
      return {
        ...state,
        instance: {},
        // 显示隐藏参数临时位置
        toggleConfig: {},
        propertiesConfigs: [],
        proxy: {},
        ctrlIndex: 1,
        requestGroup: null,
        widgets: [],
        isVisible: false,
        selectedCtrlId: '',
        ctrls: null,
        page: {}
      };
    },
    fetchPageInfo(state, { payload, pageStatus }) {
      const pageInfo = JSON.parse(payload.context);
      const { layout, ...page } = payload.page;
      const gridInfo = JSON.parse(layout);
      return {
        ...state,
        pageStatus,
        gridInfo: _.get(gridInfo, 'layoutNodes[0]', {}),
        ctrls: pageInfo.data,
        page,
        proxy: pageInfo.proxy || {},
        ctrlIndex: pageInfo.ctrlIndex || 1
      };
    },
    addGrid(state, { ctrl, ctrlIndex, index }) {
      const { ctrls, ctrlIndex: oldCtrlIndex } = state;
      const resultCtrl = {};
      const gridId = `grid-${ctrlIndex}`;
      const { id } = ctrl;

      const parent = _.cloneDeep(ctrls[id]);
      const gridCtrl = ctrls[gridId] || createGridNode({
        id: gridId,
        parentId: id,
        index: parent.children.length
      });
      resultCtrl[gridId] = gridCtrl;
      if (!ctrls[gridId]) {
        const rowNum = 3;
        const colNum = 3;
        for (let i = 0; i < rowNum; i += 1) {
          const rowId = `ctrl-${ctrlIndex}_${i}`;
          const rowCtrl = createCtrl({
            id: rowId,
            parentId: gridId,
            type: 'GridRow',
            index: i
          });
          resultCtrl[rowId] = rowCtrl;
          for (let j = 0; j < colNum; j += 1) {
            // if (j > 0) rowCtrl.config.gridCol.push('1');
            const colId = `ctrl-${ctrlIndex}_${i}_${j}`;
            resultCtrl[colId] = createCtrl({
              id: colId,
              parentId: rowId,
              type: 'Col',
              index: j
            });
            rowCtrl.children.push(colId);
          }
          gridCtrl.children.push(rowId);
        }
      }
      ctrlIndex += 1;
      if (index !== undefined) {
        // 插入指定位置
        parent.children.splice(index, 0, gridId); // 在父节点 放入当前节点id
        parent.children.forEach((e, i) => {
          if (e !== gridId) {
            resultCtrl[e] = {
              ...ctrls[e],
              index: i
            };
          }
        });
        ctrlIndex = oldCtrlIndex;
      } else {
        parent.children.push(gridId);
      }
      resultCtrl[id] = parent;
      window.__LAYOUT_CONFIG_DATA_SAVE_STATE__ = false;
      return {
        ...state,
        ctrls: {
          ...ctrls,
          ...resultCtrl
        },
        ctrlIndex
      };
    },
    addContainer(state, { payload: { id, componentType, ctrlIndex, index } }) {
      const { ctrls, ctrlIndex: oldCtrlIndex } = state;
      const containerId = `${_.isObject(componentType) ? componentType.type : componentType}-${ctrlIndex}`;
      const resultCtrl = {};
      const currentCtrl = _.cloneDeep(ctrls[id]);
      const type = _.isString(componentType) ? componentType : componentType.type;
      const containerCtrl = ctrls[containerId] || {
        id: containerId,
        parentId: id,
        type: 'Container',
        index: index || ctrls[id].children.length,
        // config: {},
        componentType
      };
      resultCtrl[containerId] = containerCtrl;

      // 表单默认控件名称 和 控件ID一致
      if (componentType.group === 'form') {
        containerCtrl.config = {};
        containerCtrl.config.formItemId = containerId;
      }
      if (_.isObject(componentType)) {
        // 针对类型组件新增componentGroup字段
        containerCtrl.componentType = type;
        containerCtrl.componentGroup = componentType.group;
        containerCtrl.editorName = componentType.editorName;
        containerCtrl.componentConfig = componentType.config || {};
      }

      if (index !== undefined) {
        // 插入指定位置
        currentCtrl.children.splice(index, 0, containerId); // 在父节点 放入当前节点id
        currentCtrl.children.forEach((e, i) => {
          if (e !== containerId) {
            resultCtrl[e] = {
              ...ctrls[e],
              index: i
            };
          }
        });
      } else {
        currentCtrl.children.push(containerId); // 在父节点 放入当前节点id
      }

      if (ctrls[containerId]) {
        // 撤销 则不处理index
        ctrlIndex = oldCtrlIndex;
      } else {
        ctrlIndex += 1;
      }

      resultCtrl[id] = currentCtrl;
      window.__LAYOUT_CONFIG_DATA_SAVE_STATE__ = false;
      return {
        ...state,
        ctrls: {
          ...ctrls,
          ...resultCtrl
        },
        ctrlIndex
      };
    },
    // 新增行元素 row
    addCtrl(state, { payload }) {
      const { ctrls, ctrlIndex: oldCtrlIndex } = state;
      const { parentId, index } = payload;
      let { ctrlIndex } = payload;
      const ctrlId = `ctrl-${ctrlIndex}`;
      let rowItem = createCtrl({
        id: ctrlId,
        parentId,
        type: 'Row'
      });
      if (ctrls[ctrlId]) {
        // 撤销操作
        rowItem = _.cloneDeep(ctrls[ctrlId]);
        ctrlIndex = oldCtrlIndex - 2;
      }
      const resultCtrl = {};
      const parent = _.cloneDeep(ctrls[parentId]);
      resultCtrl[ctrlId] = rowItem;
      if (index !== undefined) {
        parent.children.splice(index, 0, ctrlId);
        parent.children = parent.children.map((e, i) => {
          if (e !== ctrlId) {
            resultCtrl[e] = {
              ...ctrls[e],
              index: i
            };
          } else {
            rowItem.index = i;
          }
          return e;
        });
      } else {
        rowItem.index = parent.children.length;
        parent.children.push(ctrlId);
      }

      if (!ctrls[ctrlId]) {
        // 新增操作
        const colId = `ctrl-${ctrlIndex + 1}`;
        const colCtrl = createCtrl({
          id: colId,
          parentId: ctrlId,
          type: 'Col',
          index: 0
        });
        rowItem.children.push(colId);
        resultCtrl[colId] = colCtrl;
      }
      window.__LAYOUT_CONFIG_DATA_SAVE_STATE__ = false;
      return {
        ...state,
        ctrlIndex: ctrlIndex + 2,
        ctrls: {
          ...ctrls,
          ...resultCtrl,
          [parentId]: parent
        }
      };
    },
    addCol(state, { payload }) {
      const { ctrls, ctrlIndex: stateCtrlIndex } = state;
      const { parentId, index, ctrlIndex, value } = payload;
      let { newCtrlIndex } = payload;
      const result = {};
      const ctrlId = `ctrl-${ctrlIndex}`;
      const parent = _.cloneDeep(ctrls[parentId]);
      const newCtrl = createCtrl({
        id: ctrlId,
        parentId,
        type: 'Col',
        index,
        config: {
          ratio: value
        }
      });
      result[ctrlId] = ctrls[ctrlId] || newCtrl;
      if (ctrls[ctrlId]) {
        newCtrlIndex = stateCtrlIndex;
      }
      parent.children.splice(index, 0, ctrlId);
      parent.children.forEach((e, i) => {
        const item = e === ctrlId ? result[ctrlId] : ctrls[e];
        result[e] = {
          ...item,
          index: i
        };
      });
      result[parentId] = parent;
      // parent.config.gridCol.push('1');
      window.__LAYOUT_CONFIG_DATA_SAVE_STATE__ = false;
      return {
        ...state,
        ctrls: {
          ...ctrls,
          ...result
        },
        ctrlIndex: newCtrlIndex
      };
    },
    deleteCtrlAction(state, { payload }) {
      const { ctrls, instance, propertiesConfigs } = state;
      const { id, parentId, resultConfig } = payload;
      const result = {};
      const newInstance = {
        instance,
        propertiesConfigs
      };
      const parentCtrl = _.cloneDeep(ctrls[parentId]);

      if (instance.id === id) {
        newInstance.instance = getInstanceById('ctrl-root');
        newInstance.propertiesConfigs = resultConfig.default;
      }
      result[parentId] = parentCtrl;
      parentCtrl.children = parentCtrl.children.filter(e => e !== id);
      parentCtrl.children.forEach((e, i) => {
        result[e] = {
          ..._.cloneDeep(ctrls[e]),
          index: i
        };
      });
      window.__LAYOUT_CONFIG_DATA_SAVE_STATE__ = false;
      return {
        ...state,
        ctrls: {
          ...ctrls,
          ...result
        },
        ...newInstance
      };
    },
    updateCtrl(state, { payload }) {
      const { id, config } = payload;
      const { ctrls } = state;
      return {
        ...state,
        ctrls: {
          ...ctrls,
          [id]: {
            ...ctrls[id],
            config
          }
        }
      };
    },
    updateGrid(state, { payload }) {
      const { col, row, gridId, colWidth, colIndex, id } = payload;
      const instance = getInstanceById(id);
      let { rowIndex } = payload;
      let newColIndex = 0;
      const { ctrls } = state;
      const resultCtrl = {};
      const grid = _.cloneDeep(ctrls[gridId]);
      const colChilren = ctrls[grid.children[0]];
      const ctrlIndex = +gridId.replace('grid-', '');
      // 行修改处理
      instance.config.row = row;
      instance.config.col = col;
      instance.config.colWidth = colWidth || instance.config.colWidth;
      if (grid.children.length > row) {
        grid.children.splice(row);
        resultCtrl[gridId] = grid;
      } else if (grid.children.length < row) {
        for (let i = grid.children.length; i < row; i += 1) {
          const ctrlId = `ctrl-${ctrlIndex}_${rowIndex}`;
          grid.children.push(ctrlId);
          resultCtrl[ctrlId] = ctrls[ctrlId] || createCtrl({
            id: ctrlId,
            parentId: gridId,
            type: 'GridRow',
            index: i
          });
          for (let j = 0; j < col; j += 1) {
            const colId = `ctrl-${ctrlIndex}_${rowIndex}_${j}`;
            resultCtrl[colId] = ctrls[colId] || createCtrl({
              id: colId,
              parentId: ctrlId,
              type: 'Col',
              index: j
            });
            if (!ctrls[ctrlId]) resultCtrl[ctrlId].children.push(colId);
          }
          rowIndex = +rowIndex + 1;
          resultCtrl[gridId] = grid;
        }
        instance.config.rowIndex = rowIndex;
      }

      // 列修改处理
      if (colChilren.children.length > col) {
        for (let i = 0; i < grid.children.length; i += 1) {
          const rowItem = _.cloneDeep(ctrls[grid.children[i]]);
          rowItem.children.splice(col);
          resultCtrl[grid.children[i]] = rowItem;
        }
      } else if (colChilren.children.length < col) {
        for (let i = 0; i < grid.children.length; i += 1) {
          const rowItem = _.cloneDeep(ctrls[grid.children[i]]);
          newColIndex = colIndex;
          for (let j = rowItem.children.length; j < col; j += 1) {
            const ctrlId = `ctrl-${ctrlIndex}_${i}_${newColIndex}`;
            newColIndex += 1;
            resultCtrl[ctrlId] = ctrls[ctrlId] || createCtrl({
              id: ctrlId,
              parentId: rowItem.id,
              type: 'Col',
              index: j
            });
            rowItem.children.push(ctrlId);
          }
          resultCtrl[grid.children[i]] = rowItem;
        }
        instance.config.colIndex = newColIndex;
      }
      return {
        ...state,
        ctrls: {
          ...ctrls,
          ...resultCtrl
        }
      };
    },
    addGridCol(state, { payload: { gridId, index, colIndex } }) {
      const { ctrls } = state;
      const grid = ctrls[gridId];
      const instance = getInstanceById(gridId);
      const result = {};
      grid.children.forEach((gridRowItem) => {
        result[gridRowItem] = _.cloneDeep(ctrls[gridRowItem]);
        const id = `${gridRowItem}_${colIndex}`;
        result[gridRowItem].children.splice(index, 0, id);
        result[gridRowItem].children.forEach((colId, i) => {
          const colItem = colId === id ? (ctrls[colId] || createCtrl({
            id: colId,
            parentId: gridRowItem,
            type: 'Col'
          })) : _.cloneDeep(ctrls[colId]);
          result[colId] = {
            ...colItem,
            index: i
          };
        });
      });
      instance.config.col = +instance.config.col + 1;
      if (!ctrls[`${grid.children[0]}_${colIndex}`]) {
        instance.config.colIndex = +colIndex + 1;
      }
      instance.config.colWidth = calcColWidth(instance.config.col);
      instance.forceUpdate();
      return {
        ...state,
        ctrls: {
          ...ctrls,
          ...result
        }
      };
    },
    deleteGridCol(state, { payload: { index, gridId } }) {
      const { ctrls } = state;
      const result = {};
      const instance = getInstanceById(gridId);
      const grid = _.cloneDeep(ctrls[instance.id]);
      grid.children.forEach((gridRow) => {
        const resultRow = _.cloneDeep(ctrls[gridRow]);
        resultRow.children.splice(index, 1);
        resultRow.children.forEach((itemId, i) => {
          result[itemId] = {
            ..._.cloneDeep(ctrls[itemId]),
            index: i
          };
        });
        result[gridRow] = resultRow;
      });
      instance.config.col -= 1;
      instance.config.colWidth = calcColWidth(instance.config.col);
      instance.forceUpdate();
      return {
        ...state,
        ctrls: {
          ...ctrls,
          ...result
        }
      };
    },
    addGridRow(state, { payload: { index, gridId, rowIndex } }) {
      const { ctrls } = state;
      const result = {};
      const instance = getInstanceById(gridId);
      const grid = _.cloneDeep(ctrls[gridId]);
      result[gridId] = grid;
      const gridRowId = `${gridId.replace('grid', 'ctrl')}_${rowIndex}`;
      grid.children.splice(index, 0, gridRowId);
      grid.children.forEach((gridRowItem, i) => {
        const colItem = gridRowItem === gridRowId ? (ctrls[gridRowItem] || createCtrl({
          id: gridRowItem,
          parentId: grid.id,
          type: 'GridRow'
        })) : _.cloneDeep(ctrls[gridRowItem]);
        result[gridRowItem] = {
          ...colItem,
          index: i
        };
      });
      if (!ctrls[gridRowId]) {
        for (let i = 0; i < instance.config.col; i += 1) {
          const colId = `${gridRowId}_${i}`;
          result[gridRowId].children.push(colId);
          result[colId] = createCtrl({
            id: colId,
            parentId: gridRowId,
            type: 'Col',
            index: i
          });
        }
        instance.config.rowIndex = +rowIndex + 1;
      }
      instance.config.row = +instance.config.row + 1;
      instance.forceUpdate();
      return {
        ...state,
        ctrls: {
          ...ctrls,
          ...result
        }
      };
    },
    deleteGridRow(state, { payload: { index, gridId } }) {
      const { ctrls } = state;
      const result = {};
      const instance = getInstanceById(gridId);
      const grid = _.cloneDeep(ctrls[gridId]);
      result[gridId] = grid;
      grid.children.splice(index, 1);
      grid.children.forEach((gridRow, i) => {
        result[gridRow] = {
          ..._.cloneDeep(ctrls[gridRow]),
          index: i
        };
      });
      instance.config.row -= 1;
      instance.forceUpdate();
      return {
        ...state,
        ctrls: {
          ...ctrls,
          ...result
        }
      };
    },
    copyCtrl(state, { ctrl, ctrlIndex }) {
      const { ctrls } = state;
      const sourceCtrl = ctrls[ctrl.id];
      const resultCtrl = {};
      const ctrlId = `${ctrl.id.split('-')[0]}-${ctrlIndex}`;
      const copyCtrl = _.cloneDeep(ctrls[ctrl.id]);
      const parentCtrl = _.cloneDeep(ctrls[ctrl.parentId]);
      const ctrlConfig = _.cloneDeep(getStoreConfig()[ctrl.id]);
      copyCtrl.config = ctrlConfig;
      if (ctrlConfig.position === 'absolute') {
        ctrlConfig.left = ctrlConfig.left === undefined ? 0 : ctrlConfig.left;
        ctrlConfig.top = ctrlConfig.top === undefined ? 0 : ctrlConfig.top;
        ctrlConfig.left += 5;
        ctrlConfig.top += 5;
      }
      if (ctrlConfig.style.position === 'absolute') {
        ctrlConfig.style.left += 5;
        ctrlConfig.style.top += 5;
      }
      ctrlConfig.domId = ctrlId;
      setStoreConfig({
        ...getStoreConfig(),
        [ctrlId]: ctrlConfig
      });
      copyCtrl.id = ctrlId;
      copyCtrl.index = ctrls[ctrl.parentId].children.length;
      parentCtrl.children.push(ctrlId);
      resultCtrl[ctrlId] = copyCtrl;
      resultCtrl[ctrl.parentId] = parentCtrl;
      const cloneCtrl = (item, parentId) => {
        let itemId = '';
        if (item.id.includes('_')) {
          itemId = `${item.id.split('-')[0]}-${ctrlIndex}_${item.id.split('_')[1]}_${item.id.split('_')[2]}`;
        } else {
          ctrlIndex += 1;
          itemId = `${item.id.split('-')[0]}-${ctrlIndex}`;
        }
        const copyCl = _.cloneDeep(item);
        setStoreConfig({
          ...getStoreConfig(),
          [itemId]: getStoreConfig()[copyCl.id]
        });
        copyCl.id = itemId;
        copyCl.parentId = parentId;
        resultCtrl[itemId] = copyCl;
        resultCtrl[parentId].children[copyCl.index] = itemId;
        if (item.children) {
          item.children.forEach((e) => {
            cloneCtrl(ctrls[e], itemId);
          });
        }
      };
      if (sourceCtrl.children) {
        sourceCtrl.children.forEach((e) => {
          cloneCtrl(ctrls[e], ctrlId);
        });
      }
      ctrlIndex += 1;
      window.__LAYOUT_CONFIG_DATA_SAVE_STATE__ = false;
      return {
        ...state,
        ctrls: {
          ...ctrls,
          ...resultCtrl
        },
        ctrlIndex
      };
    },
    modifyCtrl(state, { payload: { sourceId, targetId, id, index } }) {
      const { ctrls } = state;
      const resultCtrl = {};
      const currentCtrl = _.cloneDeep(ctrls[id]);
      const targetCtrl = _.cloneDeep(ctrls[targetId]);
      const sourceCtrl = _.cloneDeep(ctrls[sourceId]);

      const childList = targetCtrl.children.join('');
      if (isSameType(childList, id)) {
        message.error('区块内不能存在不同类型组件');
        return;
      }
      currentCtrl.parentId = targetId;
      // currentCtrl.index = targetCtrl.children.length;
      sourceCtrl.children = sourceCtrl.children.filter(e => e !== id);
      sourceCtrl.children.forEach((e, i) => {
        resultCtrl[e] = {
          ...ctrls[e],
          index: i
        };
      });
      // 目标数据整理
      targetCtrl.children.splice(index, 0, id);
      targetCtrl.children.forEach((e, i) => {
        let item = ctrls[e];
        if (e === id) item = currentCtrl;
        resultCtrl[e] = {
          ...item,
          index: i
        };
      });
      window.__LAYOUT_CONFIG_DATA_SAVE_STATE__ = false;
      window.requestIdleCallback(() => {
        $(`#${id}`).click();
      });
      return {
        ...state,
        ctrls: {
          ...ctrls,
          [sourceId]: sourceCtrl,
          [id]: currentCtrl,
          [targetId]: targetCtrl,
          ...resultCtrl
        }
      };
    },
    moveCtrl(state, { payload: { id, parentId, index } }) {
      const { ctrls } = state;
      const result = {};
      const parent = _.cloneDeep(ctrls[parentId]);
      parent.children = parent.children.filter(e => e !== id);
      parent.children.splice(index, 0, id);
      parent.children = parent.children.map((e, i) => {
        result[e] = {
          ...ctrls[e],
          index: i
        };
        return e;
      });
      window.__LAYOUT_CONFIG_DATA_SAVE_STATE__ = false;
      window.requestIdleCallback(() => {
        $(`#${id}`).click();
      });
      return {
        ...state,
        ctrls: {
          ...ctrls,
          [parentId]: parent,
          ...result
        }
      };
    },
    updateCtrls(state, { ctrls, ctrlIndex = state.ctrlIndex }) {
      return {
        ...state,
        ctrls: {
          ...ctrls
        },
        ctrlIndex
      };
    },
    updateCtrlIndex(state, { ctrlIndex }) {
      return {
        ...state,
        ctrlIndex
      };
    },
    updateEditConfig(state, { payload }) {
      const { path, value, control } = payload;
      const { editConfig } = state;
      const config2Set = _.cloneDeep(editConfig);

      // 有swich控制显示 隐藏时更新
      if (control && control.toggle) {
        // const { path: pathArr } = control.toggle;
        // if (_.isArray(pathArr)) {
        //   if (value) {
        //     _.each((item) => {
        //       if (toggleConfig[item]) {
        //         L.set(config2Set.config, item, toggleConfig[item]);
        //         delete toggleConfig[item];
        //       }
        //     })(pathArr);
        //   } else {
        //     _.each((item) => {
        //       toggleConfig[item] = L.get(config2Set.config, item);
        //       L.set(config2Set.config, item, '');
        //     })(pathArr);
        //   }
        // }
        _.set(config2Set.config, control.toggle.path, control.toggle.callback(value));
      }
      if (_.isObject(value)) {
        _.set(config2Set.config, `${value.path}.${value.id}`, value.value);
      }
      // 如果是单值更新
      if (_.isString(path)) {
        _.set(config2Set, `config.${path}`, value);
      }
      window.__LAYOUT_CONFIG_DATA_SAVE_STATE__ = false;
      return {
        ...state,
        editConfig: config2Set
      };
    },
    // 组件第一次加载完成时，把内部状态初始化到redux中
    initComponentConfigs(state, { payload }) {
      let { ctrls } = state;
      const { configs, id } = payload;
      if (ctrls[id]) {
        ctrls = {
          ...ctrls,
          [id]: {
            ...ctrls[id],
            config: configs
          }
        };
      }
      return {
        ...state,
        ctrls
      };
    },
    gotEditComp(state, { instance, result }) {
      return {
        ...state,
        instance,
        propertiesConfigs: result
      };
    },
    gotWidgetsByGroup(state, action) {
      return {
        ...state,
        requestGroup: action.requestGroup.groupName,
        widgets: action.widgets
      };
    },
    resetState(state) {
      const initState = {
        instance: {},
        toggleConfig: {},
        propertiesConfigs: [],
        ctrls: defaultCtrls,
        ctrlIndex: 1,
        requestGroup: null,
        widgets: [],
        selectedCtrlId: ''
      };
      return {
        ...state,
        ...initState
      };
    },
    multipleSelect(state, { instance, result }) {
      let newInstance = [].concat(state.instance);
      if (newInstance.includes(instance)) {
        newInstance = newInstance.filter(e => e !== instance);
      } else {
        newInstance.push(instance);
      }
      return {
        ...state,
        instance: newInstance,
        propertiesConfigs: result
      };
    },
    displayDiaglog(state, { isVisible, pageStatus, lockStaffName, lastModifiedTime }) {
      return {
        ...state,
        pageStatus,
        isVisible,
        lockStaffName,
        lastModifiedTime
      };
    },
    setFreshId(state, { freshId }) {
      return {
        ...state,
        freshId
      };
    }
    // updateLayoutConfigSaveState(state, { layoutConfigSaveState }) {
    //   return {
    //     ...state,
    //     layoutConfigSaveState
    //   };
    // }
  }
};

